module.exports = __webpack_public_path__ + "static/media/nepal-map-on.5d34987b.png";